import React, { useState, useEffect } from 'react';
import Header from '../../components/Header';
import api from '../../services/api_irrigacao';
import { LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip } from 'recharts';
import moment from 'moment';
import { format } from 'date-fns-tz';

export default function Auditoria() {


    var largura = window.screen.width - 100;
    var altura = window.screen.height - 500;

    const [dados, setDados] = useState([]);
    const [lowers, setLowers] = useState([]);

    useEffect(() => {
        api.get(`/audit`).then(function (response) {
            if (response.data) {
                var info = [];
                response.data.map(dado => {
                    var created = format(new Date(dado.createdAt), 'dd/MM/yyyy HH:mm');
                    moment(dado.createdAt).utc().format('DD/MM/yyyy HH:mm');
                    var time = dado.time / 1000;
                    var rota = dado.rota.split('/')[1];
                    info.push({ hora: created, tempo: time, rota: rota, usuario: dado.user })
                })
                setDados(info);
            }
        }).catch(function (error) {
            // handle error
            alert(error);
            console.log(error);
        }).then(function () {
            // always executed
        });

    }, []);

    useEffect(() => {
        api.get(`/audit/lower`).then(function (response) {
            if (response.data) {
                setLowers(response.data)
            }
        }).catch(function (error) {
            // handle error
            alert(error);
            console.log(error);
        }).then(function () {
            // always executed
        });

    }, []);

    function renderRowsLowers() {
        return (
            lowers.map(dados => {
                return (
                    <tr>
                        <td>{dados.usuario}</td>
                        <td>{(dados && dados.media ? dados.media/1000 : 0).toFixed(0)}</td>
                        <td>{dados.qtd}</td>
                    </tr>
                )
            })
        )
    }

    return (
        <>
            <div className="container-lg">
                <Header title="AUDITORIA" />
                <h3>QUANTIDADE DE REQUISIÇÕES MAIORES QUE 3 SEGUNDOS POR USUÁRIO NAS ULTIMAS 12 HORAS</h3>
                <table className='table table-sm tb-lowers'>
                    <thead>
                        <tr>
                            <th>USUARIO</th>
                            <th>MÉDIA DE TEMPO EM SEGUNDOS</th>
                            <th>QUANTIDADE</th>
                        </tr>
                    </thead>
                    <tbody>
                        {renderRowsLowers()}
                    </tbody>
                </table>
            </div>
            <LineChart width={largura} height={300} data={dados} margin={{ top: 5, right: 20, bottom: 5, left: 0 }}>
                <Line type="hora" dataKey="tempo" stroke="#8884d8" />
                <Line type="hora" dataKey="rota" stroke="#8884d8" />
                <Line type="hora" dataKey="usuario" stroke="#8884d8" />
                <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
                <XAxis dataKey="hora" />
                <YAxis />
                <Tooltip />
            </LineChart>
        </>
    )

}